export default {
      id: "about-symbols-02-usage",
      viewBox: "0 0 150 150",
      url: "/" + "sprite.svg#about-symbols-02",
      toString: function () {
        return this.url;
      }
    }